import * as yup from 'yup'
export const createJobCategorySchema = yup.object().shape({
    title: yup.string().required('Chưa nhập tên loại việc làm'),
    description: yup.string().required('Chưa nhập mô tả loại việc làm'),
})
